import { render, staticRenderFns } from "./CheckLogin.vue?vue&type=template&id=1ff23a2d"
import script from "./CheckLogin.vue?vue&type=script&lang=js"
export * from "./CheckLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports